import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./AuthContext";
import { ErrorBoundary } from "./ErrorBoundary";
import { SiteHeader } from "../components/SiteHeader";
import { SiteFooter } from "../components/SiteFooter";
import { LandingPage } from "../pages/LandingPage";
import { BrandExplorerPage } from "../pages/BrandExplorerPage";
import { BrandProfilePage } from "../pages/BrandProfilePage";
import { CategoryPage } from "../pages/CategoryPage";
import { TagPage } from "../pages/TagPage";
import { SearchPage } from "../pages/SearchPage";
import { SavedBrandsPage } from "../pages/SavedBrandsPage";
import { SubmitBrandPage } from "../pages/SubmitBrandPage";
import { AboutPage } from "../pages/AboutPage";
import { LoginPage } from "../pages/LoginPage";
import { NotFoundPage } from "../pages/NotFoundPage";
import { AdminDashboardPage } from "../pages/AdminDashboardPage";
import { AdminCandidatesPage } from "../pages/AdminCandidatesPage";
import { AdminCandidatePage } from "../pages/AdminCandidatePage";
import { AdminBrandsPage } from "../pages/AdminBrandsPage";
import { AdminBrandEditPage } from "../pages/AdminBrandEditPage";
import { AdminTagsPage } from "../pages/AdminTagsPage";
import { AdminSourcesPage } from "../pages/AdminSourcesPage";
import { AdminImportPage } from "../pages/AdminImportPage";
import { AdminSocialPage } from "../pages/AdminSocialPage";

export function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="app-shell">
          <SiteHeader />
          <main className="app-main">
            <ErrorBoundary>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/brands" element={<BrandExplorerPage />} />
              <Route path="/brands/:slug" element={<BrandProfilePage />} />
              <Route path="/categories" element={<CategoryPage />} />
              <Route path="/categories/:slug" element={<CategoryPage />} />
              <Route path="/tags/:slug" element={<TagPage />} />
              <Route path="/search" element={<SearchPage />} />
              <Route path="/saved" element={<SavedBrandsPage />} />
              <Route path="/submit" element={<SubmitBrandPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/admin" element={<AdminDashboardPage />} />
              <Route path="/admin/candidates" element={<AdminCandidatesPage />} />
              <Route path="/admin/candidates/:id" element={<AdminCandidatePage />} />
              <Route path="/admin/brands" element={<AdminBrandsPage />} />
              <Route path="/admin/brands/:id" element={<AdminBrandEditPage />} />
              <Route path="/admin/tags" element={<AdminTagsPage />} />
              <Route path="/admin/sources" element={<AdminSourcesPage />} />
              <Route path="/admin/import" element={<AdminImportPage />} />
              <Route path="/admin/social" element={<AdminSocialPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
            </ErrorBoundary>
          </main>
          <SiteFooter />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}
